export const NONE = '适用车型无限制'
export const FIVE_OR_LESS_CAR = '适用五座及以下小轿车'
export const FIVE_OR_LESS_SUV = '适用五座及以下SUV'
export const FIVE_MORE_SUV_MPV = '适用五座以上SUV/MPV'



// WEBPACK FOOTER //
// ./src/constants/terms/suitable-types.js